import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=1a352670&lang=pug&"
import script from "./overlay.vue?vue&type=script&lang=js&"
export * from "./overlay.vue?vue&type=script&lang=js&"
import style0 from "./overlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a352670')) {
      api.createRecord('1a352670', component.options)
    } else {
      api.reload('1a352670', component.options)
    }
    module.hot.accept("./overlay.vue?vue&type=template&id=1a352670&lang=pug&", function () {
      api.rerender('1a352670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overlay.vue"
export default component.exports